export default "__VITE_ASSET__a4250dd7__"